module.exports = __webpack_public_path__ + "img/jasonmethodsequence2_thumb.b7c3db2a.jpg";